import { Link, useNavigate } from "react-router-dom";
import "../Components/Header.css";
import cross from "../Components/Assets/Home-Header-Footer/cross.png";
import { useUser } from "../Components/Context/UserContext";
import { useState } from "react";

/**
 * Header component that provides navigation and user authentication UI
 * Includes responsive design with mobile sidebar and desktop navbar
 */
export function Header() {
  const { user, logout } = useUser();
  const [showLogout, setShowLogout] = useState(false);
  const navigate = useNavigate();

  /**
   * Shows the mobile sidebar navigation
   */
  function showSidebar(event) {
    event.preventDefault();
    const sidebar = document.querySelector(".sidebar");
    sidebar.style.display = "flex";
  }

  /**
   * Hides the mobile sidebar navigation
   */
  function hideSidebar(event) {
    event.preventDefault();
    const sidebar = document.querySelector(".sidebar");
    sidebar.style.display = "none";
  }

  /**
   * Toggles the user dropdown menu visibility
   */
  const toggleLogout = () => {
    setShowLogout(!showLogout);
  };

  /**
   * Handles user logout functionality
   */
  const handleLogout = (e) => {
    e.preventDefault();
    logout();
    setShowLogout(false);
  };

  /**
   * Navigates to the change password page
   */
  const handleChangePassword = (e) => {
    e.preventDefault();
    setShowLogout(false);
    navigate("/reset-password");
  };

  /**
   * Closes dropdown when clicking outside
   */
  const closeDropdown = () => {
    setShowLogout(false);
  };

  return (
    <div className="nav-bar" onClick={closeDropdown}>
      <header>
        <nav>
          {/* Mobile sidebar navigation */}
          <ul className="sidebar">
            <li onClick={hideSidebar}>
              <img className="cross-icn" src={cross} alt="Close menu" />
            </li>
            <li onClick={hideSidebar}>
              <Link to="/">Home</Link>
            </li>
            <li onClick={hideSidebar}>
              <Link to="/service">Services</Link>
            </li>
            {user && (
              <li onClick={hideSidebar}>
                <Link to="/management">Portal</Link>
              </li>
            )}
            <li onClick={hideSidebar}>
              <Link to="/blog">Blog</Link>
            </li>
            <li onClick={hideSidebar}>
              <Link to="/contact">Contact Us</Link>
            </li>
            <li onClick={hideSidebar}>
              <div className="username-logout-buttons">
                {user ? (
                  <div className="mobile-user-menu">
                    <div
                      className="mobile-username"
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleLogout();
                      }}
                    >
                      {user.username}
                    </div>
                    {showLogout && (
                      <div className="mobile-user-dropdown">
                        <Link
                          to="/management"
                          className="change-password-button"
                        >
                          Portal
                        </Link>
                        <Link
                          className="change-password-button"
                          onClick={handleChangePassword}
                        >
                          Change Password
                        </Link>
                        <Link className="logout-button" onClick={handleLogout}>
                          Logout
                        </Link>
                      </div>
                    )}
                  </div>
                ) : (
                  <Link className="login-name" to="/login">
                    <button
                      type="submit"
                      className="cssbuttons-io-button-header"
                    >
                      Login
                      <div className="icon">
                        <svg
                          height="24"
                          width="24"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M0 0h24v24H0z" fill="none"></path>
                          <path
                            d="M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z"
                            fill="currentColor"
                          ></path>
                        </svg>
                      </div>
                    </button>
                  </Link>
                )}
              </div>
            </li>
          </ul>

          {/* Desktop navigation */}
          <ul className="desk-navbar">
            <li>
              <div className="logo">
                <Link to="/">
                  <img src="https://productionhussmestorage.blob.core.windows.net/hussmeassets/hussme-white-web.png" alt="Hussme Logo" />
                </Link>
              </div>
            </li>
            <li className="hideWhileMobileOn">
              <Link to="/" className="logo-link">
                Home
              </Link>
            </li>
            <li className="hideWhileMobileOn">
              <Link to="/service" className="logo-link">
                Services
              </Link>
            </li>
            {user && (
              <li className="hideWhileMobileOn">
                <Link to="/management" className="logo-link">
                  Portal
                </Link>
              </li>
            )}
            <li className="hideWhileMobileOn">
              <Link to="/blog" className="logo-link">
                Blog
              </Link>
            </li>
            <li className="hideWhileMobileOn">
              <Link to="/contact" className="logo-link">
                Contact Us
              </Link>
            </li>
            <li className="hideWhileMobileOn">
              {user ? (
                <div
                  className="user-dropdown-container"
                  onClick={(e) => e.stopPropagation()}
                >
                  <span className="header-desk-username" onClick={toggleLogout}>
                    {user.username}
                  </span>
                  {showLogout && (
                    <div className="logout-dropdown">
                      <Link to="/management" className="change-password-button">
                        Portal
                      </Link>
                      <Link
                        className="change-password-button"
                        onClick={handleChangePassword}
                      >
                        Change Password
                      </Link>
                      <Link className="logout-button" onClick={handleLogout}>
                        Logout
                      </Link>
                    </div>
                  )}
                </div>
              ) : (
                
              <Link to="/login" className="logo-link">
                Login
              </Link>
            
                // <Link className="login-name" to="/login">
                //     Login
                //   {/* <button type="submit" className="cssbuttons-io-button-header">
                //     <div className="icon">
                //       <svg
                //         height="24"
                //         width="24"
                //         viewBox="0 0 24 24"
                //         xmlns="http://www.w3.org/2000/svg"
                //       >
                //         <path d="M0 0h24v24H0z" fill="none"></path>
                //         <path
                //           d="M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z"
                //           fill="currentColor"
                //         ></path>
                //       </svg>
                //     </div>
                //   </button> */}
                // </Link>
              )}
            </li>
            {/* Mobile menu button */}
            <li className="menu-button" onClick={showSidebar}>
              <Link to="#">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="40px"
                  viewBox="0 -960 960 960"
                  width="40px"
                  fill="#FFFFFF"
                >
                  <path d="M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z" />
                </svg>
              </Link>
            </li>
          </ul>
        </nav>
      </header>
    </div>
  );
}
